<template>
  <v-card outlined max-width="380" class="mb-5">
    <v-card-subtitle>
      <PostStatus :post="post" />
    </v-card-subtitle>
    <v-divider />

    <v-card-actions class="px-4">
      <v-row v-if="mode == 'readonly'" class="px-5">
        <PostPreviewBtn :post-id="post.id" :mode="mode" />
      </v-row>
      <v-row v-else align="center" justify="space-between">
        <v-col cols="6">
          <PostPreviewBtn :post-id="post.id" :mode="mode" />
        </v-col>
        <v-col cols="5">
          <PostSaveBtn :post="post" />
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import PostPreviewBtn from '@/components/postEditor/parts/PostPreviewBtn'
import PostSaveBtn from '@/components/postEditor/parts/PostSaveBtn'
import PostStatus from '@/components/postEditor/parts/PostStatus'

export default {
  components: {
    PostSaveBtn,
    PostStatus,
    PostPreviewBtn
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post,
      mode: (state) => state.PostEditor.mode,
      currentUser: (state) => state.UserStore.currentUser
    })
  }
}
</script>
